import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const VideoWrapper = styled.video.attrs(({ align }) => ({
  align: align,
}))`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: ${({ align }) => (align === "full" ? "1570px" : "1180px")};
  min-height: ${({ align }) => (align === "full" ? "60vh" : "40vh")};
  @media (max-width: 940px) {
    min-height: ${({ align }) => (align === "full" ? "300px" : "300px")};
  }
`;

const Video = ({ src, poster, preload, align }) => {
  return (
    <VideoWrapper
      align={align}
      preload={preload}
      poster={poster}
      loop
      autoPlay
      muted
      src={src}
    />
  );
};

Video.propTypes = {
  src: PropTypes.string,
  align: PropTypes.string,
  poster: PropTypes.string,
  preload: PropTypes.string,
};

Video.defaultProps = {
  src: undefined,
};

export default Video;
